import { IsNotEmpty, IsNumberString, MaxLength, Validate, IsDefined } from 'class-validator';

import { DisplayNameValidation } from 'src/core/customValidator/displayNameValidator';
import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class AirportDataService extends DataService<typeof Model.General.Logic.ViewModels.AirportItem, Model.General.Logic.ViewModels.AirportItem, AirportItem> {
	protected map(entity: Model.General.Logic.ViewModels.AirportItem): AirportItem {
		return new AirportItemModel(entity);
	}

	public static make(ctx?: any): AirportDataService {
		return new AirportDataService(ctx, ctx => ctx.Airports);
	}

	public add(defaultLanguage: string, type?: string) {
		const entity = new Model.General.Logic.ViewModels.AirportItem();
		(entity as any).dynamicProperties['displayName'] = { [defaultLanguage]: '' };
		entity.type = 1;
		return entity;
	}
}

export class AirportItemModel extends EntityModel<Model.General.Logic.ViewModels.AirportItem, TaxItem> implements AirportItem {
	
	@property<AirportItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<AirportItemModel>(o => o.entity.regionId, (o, value) => o.entity.regionId = value)
	public regionId: number;

    @property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
    @Validate(DisplayNameValidation, ['en'])
	public dynamicProperties: {};

	@property<AirportItemModel>(o => o.entity.type, (o, value) => o.entity.type = value)
	public type: number;

    @property<AirportItemModel>(o => o.entity.code, (o, value) => o.entity.code = value)
    @IsDefined({ message: 'code is required' })
    @MaxLength(3, { message: 'code is to long' })
	public code: string;

	@property<AirportItemModel>(o => o.entity.parentPlaceId, (o, value) => o.entity.parentPlaceId = value)
	public parentPlaceId?: number;

    @property<AirportItemModel>(o => o.entity.location, (o, value) => o.entity.location = value)
    public location: any;
}



// WEBPACK FOOTER //
// ./src/app/general/airports/form/airport-form.data.ts